import React from 'react';
import Title from '../layouts/Title';
import { projectOne, projectTwo, projectThree } from "../../assets/index";
import ProjectsCard from './ProjectsCard';

const Projects = () => {
  return (
    <section
      id="projects"
      className="w-full py-20 border-b-[1px] border-b-black"
    >
      <div className="flex justify-center items-center text-center">
        <Title
          title="VISIT MY PORTFOLIO AND KEEP YOUR FEEDBACK"
          des="My Projects"
        />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6 xl:gap-14">
        <ProjectsCard
          title="YELP CAMP SITE"
          des="Yelpcamp is a website where users go to book available campgrounds around the world. In this site users are able to see prices, and the beauty of the campground."
          src={projectOne}
          githubLink="https://github.com/U-I-DUTSE/yelpCamp"
          websiteLink="https://myyelpcamp-ec11.onrender.com"
        />
        <ProjectsCard
          title="BAFFAT STORE"
          des="Baffat store is a store that sells all kinds of electronics and gadgets. This was an admin dashboard created for the store, you can see how the page is build."
          src={projectTwo}
          githubLink="https://github.com/U-I-DUTSE/Admindashboard"
          websiteLink="https://baffatstore.vercel.app/"
        />
        <ProjectsCard
          title="VIDLY MOVIE SITE"
          des="Vidly movie site is a site where you can find available movies in a the collection of a certain shop, and you can be able to search the film that you want to buy or watch."
          src={projectThree}
          githubLink="https://github.com/U-I-DUTSE/movieapp"
          websiteLink="https://movieapp-virid-chi.vercel.app/"
        />
      </div>
    </section>
  );
};

export default Projects;
